import CONSTANTS from './constants';

const setDashboardLoading = ({ commit }, loading): void => {
  commit(CONSTANTS.SET_DASHBOARD_STATUS_LOADING, loading);
};

export default {
  setDashboardLoading,
};
